import { Grid } from "@material-ui/core";
import React, { FC } from "react";
import { useIntl } from "react-intl";
import { RoomAssignmentViewModel } from "../../model/RoomAssignmentViewModel";
import { RoomViewModel } from "../../model/RoomViewModel";
import { GetTranslation } from "../../translations/GetTranslation";
import CustomSwitch from "../common/CustomSwitch";
import FormGridCell from "../common/FormGridCell";
import { CustomAutocomplete } from "../common/customAutocomplete/CustomAutocomplete";
import LanguageCheckboxList from "../common/customCheckBox/LanguageCheckboxList";
import TranslatedMessage from "../translations/TranslatedMessage";

export interface IRoomAssignmentErrors {
  room?: boolean;
}

interface IRoomAssignmentFieldsProps {
  roomAssignment: RoomAssignmentViewModel;
  onPropertyValueChanges?: (part: Partial<RoomAssignmentViewModel>) => void;
  rooms: RoomViewModel[];
  errors?: IRoomAssignmentErrors;
  onSelectedLanguagesChanged?: (checkedItems: string[]) => void;
  availableLanguages: string[];
  showPreparationRoomSwitch: boolean;
  disablePreparationRoomSwitch?: boolean;
}

export const RoomAssignmentFields: FC<IRoomAssignmentFieldsProps> = ({
  availableLanguages,
  showPreparationRoomSwitch,
  disablePreparationRoomSwitch,
  roomAssignment,
  rooms,
  errors,
  ...handlers
}) => {
  const intl = useIntl();

  const handleChange = (key: keyof RoomAssignmentViewModel, value: string | boolean | undefined) => {
    let part: Partial<RoomAssignmentViewModel> = {
      [key]: value,
    };
    handlers.onPropertyValueChanges!(part);
  };

  const selectedRoom = rooms.find((room) => room.id === roomAssignment.roomId) || null;
  return (
    <Grid container={true} spacing={1}>
      <FormGridCell size="half">
        <CustomAutocomplete
          label={GetTranslation(intl, "roomAssignment.field.room")}
          options={rooms}
          getOptionLabel={(room) => room.name}
          value={selectedRoom}
          onChange={(_event, value) => handleChange("roomId", value?.id)}
          required={true}
          error={errors?.room}
        />
      </FormGridCell>
      <FormGridCell size="half">
        <LanguageCheckboxList
          availableLanguages={availableLanguages}
          required={true}
          label={GetTranslation(intl, "expert.field.languages")}
          checkedLanguages={roomAssignment.languages}
          onSelectedLanguagesChanged={handlers.onSelectedLanguagesChanged}
        />
      </FormGridCell>
      <FormGridCell size="half" />
      {showPreparationRoomSwitch && (
        <FormGridCell size="medium">
          <CustomSwitch
            label={<TranslatedMessage id="roomAssignment.field.isPreparationRoom" />}
            onChange={(value) => handleChange("isPreparationRoom", value)}
            value={roomAssignment.isPreparationRoom}
            disabled={disablePreparationRoomSwitch}
          />
        </FormGridCell>
      )}
      <FormGridCell size="fill" />
    </Grid>
  );
};
